// extracted by mini-css-extract-plugin
module.exports = {"editableTableElement":"styles_editableTableElement__3UKqj","inNotebook":"styles_inNotebook__OCIJb","resetButton":"styles_resetButton__2GliB"};